import { useAuthClient } from '../hooks/useAuthClient'
import { Dashboard } from '../views/Dashboard'
import { Login } from '../views/Login'

export const AuthRouter = (): JSX.Element => {
  const { isAuthed, isLoading } = useAuthClient()
  return isAuthed ? <Dashboard /> : <Login loading={isLoading} />
}
